import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { ToggleGroup, ToggleGroupItem } from '@musa.tech/design-system';
import { MinhasSolicitacoesTab } from './MinhasSolicitacoesTab';
import { MinhasCacambasList } from './MinhasCacambasList';

/** `servico=cacamba` na URL: a lista e a nova solicitação abrem em movimentação de equipamento. */
export const SERVICE_PARAM = 'servico';
export const BUCKET_SERVICE = 'cacamba';

export function useOnDemandServiceParam(): [boolean, (bucket: boolean) => void] {
  const [searchParams, setSearchParams] = useSearchParams();
  const isBucket = searchParams.get(SERVICE_PARAM) === BUCKET_SERVICE;

  const setBucket = (bucket: boolean) =>
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        if (bucket) next.set(SERVICE_PARAM, BUCKET_SERVICE);
        else next.delete(SERVICE_PARAM);
        return next;
      },
      { replace: true },
    );

  return [isBucket, setBucket];
}

/** A aba de sob demanda no fluxo novo: solicitações de coleta e movimentações de equipamento. */
export const SolicitacoesSobDemandaAgreements: React.FC = () => {
  const [isBucket, setBucket] = useOnDemandServiceParam();

  return (
    <div className="flex flex-col gap-4">
      <ToggleGroup
        type="single"
        value={isBucket ? 'bucket' : 'collect'}
        onValueChange={(next) => next && setBucket(next === 'bucket')}
        className="justify-start"
        aria-label="Coletas ou movimentações de equipamento"
      >
        <ToggleGroupItem value="collect">Coletas</ToggleGroupItem>
        <ToggleGroupItem value="bucket">Movimentação de Equipamentos</ToggleGroupItem>
      </ToggleGroup>

      {isBucket ? <MinhasCacambasList /> : <MinhasSolicitacoesTab />}
    </div>
  );
};
